import React, { Fragment } from 'react';
import { ButtonAction, Description, DescriptionText, LinkArrow, StyledTitle, TitleLink, TitleSection } from './MediaListTitle.styles';
import SvgChevron from '../../../../play-core/icons/Chevron';
import { useAnalyticsDispatch } from '../../analytics/AnalyticsContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MediaListTitle = ({
  title,
  description,
  actionButton,
  titleLink
}) => {
  const analytics = useAnalyticsDispatch();
  const titleSection = /*#__PURE__*/_jsxs(TitleSection, {
    children: [title, titleLink && title && /*#__PURE__*/_jsx(LinkArrow, {
      children: /*#__PURE__*/_jsx(SvgChevron, {
        orientation: "right"
      })
    })]
  });
  return /*#__PURE__*/_jsxs(StyledTitle, {
    style: {
      paddingBottom: title.trim() ? undefined : 0
    },
    children: [title && /*#__PURE__*/_jsx(Fragment, {
      children: titleLink ? /*#__PURE__*/_jsx(TitleLink, {
        to: titleLink,
        onClick: () => analytics({
          type: 'click-event',
          name: 'SectionSubPageClick',
          value1: window.document.title,
          value2: title
        }),
        children: titleSection
      }) : titleSection
    }), title && actionButton && /*#__PURE__*/_jsx(ButtonAction, {
      type: "text",
      size: "small",
      text: actionButton.text,
      onClick: actionButton.onAction
    }), title && description && /*#__PURE__*/_jsx(Description, {
      children: /*#__PURE__*/_jsx(DescriptionText, {
        children: description
      })
    })]
  });
};